// assets/svgs/process/index.ts

export { default as DiamondSVG } from './diamond.svg';
export { default as AuditSVG } from './audit.svg';
export { default as DimentCoinSVG } from './diment-coin.svg';
export { default as StorageSVG } from './storage.svg';
export { default as UsdSVG } from './usd.svg';
